export const authInitialState = {
  loggedIn: false,
  loggedInUser: null,
  signUpUser: null,
  categories: [],
};

export const authReducer = (state, action) => {
  switch (action.type) {
    case "Logged_In_User":
      state.loggedIn = true;
      state.loggedInUser = action.payload;
      return {
        ...state,
      };
    case "LOGOUT_USER":
      state.loggedIn = false
      state.loggedInUser = null;
      return {
        ...state,
      };
      case "ALL_CATEGORIES":
        state.categories= action.payload
      return {
          ...state,
          categories:[...state.categories]
      };
    default:
      break;
  }
};
